import { GoogleOAuthProvider } from '@react-oauth/google'
import { useEffect } from 'react'
import { useAuthData } from 'src/components/auth/util'
import { useParsedRouter } from 'src/layout/hooks/use-parsed-router'
import { LOGIN_PATH } from 'src/utils/constants'
import { init } from 'commandbar'

export const CommandBar = () => {
  const authData = useAuthData()
  const orgId = '2709396b'

  // Initialize CommandBar
  useEffect(() => {
    if (!authData) {
      return
    }
    init(orgId)
    void window.CommandBar?.boot(authData.id)
  }, [])
  return null
}

type AuthProps = {
  children?: React.ReactNode
}

export const AuthProvider = (props: AuthProps) => {
  const { redirect } = useParsedRouter()
  const authData = useAuthData()

  // Not logged in -> redirect to login
  if (!authData) {
    redirect(LOGIN_PATH)
    return null
  }

  // Check only for non-admins
  // TODO(ss) Temp remove expiry check
  // if (authData.role !== Role.admin) {
  //   // Either their tier is not allowed or their subscription has expired
  //   if (!ALLOWED_TIERS.includes(authData.tier) || Date.now() > new Date(authData.expires).getTime()) {
  //     // For premium users, redirect to premium expired page
  //     if (authData.tier === 'premium') {
  //       redirect(PREMIUM_EXPIRED_PATH)
  //     }
  //     // For trial users, redirect to trial expired page
  //     else {
  //       redirect(TRIAL_EXPIRED_PATH)
  //     }
  //     return null
  //   }
  //   // a legit paying customer, go forth and explore
  // }

  return (
    <>
      <CommandBar />
      {props.children}
    </>
  )
}

export const GoogleAuthProvider = (props: AuthProps) => {
  return (
    <GoogleOAuthProvider clientId="794533836591-34abj8cq0d3creedq86ae4cb90d8jb02.apps.googleusercontent.com">
      {props.children}
    </GoogleOAuthProvider>
  )
}
